import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

// MeterAssignment (FNP-217). Binds a MeterDefinition to a customer on a specific
// billing channel, carrying the channel-specific identifiers used to report
// usage downstream (Stripe subscription item, AWS Marketplace dimension, etc.).
// Per the FNP-212 design the table is composite-key: PK customerId, SK sortKey
// (= `meterId#channel`). sortKey is server-derived and read-only.

// FNP-616: `channel` is no longer a closed enum — it is a catalog-validated lowercase token
// (the `key` of an ENABLED BillingProvider). The selectable set is fetched at runtime via
// useChannelOptions; this type is just the canonical token string.
export type BillingChannel = string;

export enum AssignmentStatus {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    CANCELED = 'CANCELED',
}

// channelIdentifiers is an AWSJSON scalar on the wire (a JSON-encoded string),
// but is carried as a parsed object in the form / client model. Shape varies by
// channel: { subscriptionItemId } for STRIPE, { customerIdentifier, dimension }
// for AWS_MARKETPLACE.
export type ChannelIdentifiers = Record<string, unknown>;

export type MeterAssignment = {
    id: string,
    customerId: string,
    meterId: string,
    sortKey?: string,
    channel: BillingChannel,
    channelIdentifiers: ChannelIdentifiers,
    freeTierQuantity?: number,
    committedQuantity?: number,
    status: AssignmentStatus,
    effectiveFrom: string,
    effectiveTo?: string,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface IMeterAssignmentTableColumn extends ITableColumn {
    render?: (item: MeterAssignment) => ReactNode;
}
